import { createContext, useContext, type ReactNode } from 'react'
import type { BackendClient } from '@saip/backend'
import type { HostAdapter, HostKind } from '@saip/office'

interface SaipContextValue {
  backend: BackendClient
  adapter: HostAdapter
  host: HostKind
}

const SaipContext = createContext<SaipContextValue | null>(null)

export interface SaipProviderProps {
  backend: BackendClient
  adapter: HostAdapter
  host: HostKind
  children: ReactNode
}

export function SaipProvider({ backend, adapter, host, children }: SaipProviderProps) {
  return <SaipContext.Provider value={{ backend, adapter, host }}>{children}</SaipContext.Provider>
}

export function useSaip(): SaipContextValue {
  const ctx = useContext(SaipContext)
  if (!ctx) throw new Error('useSaip must be used within <SaipProvider>')
  return ctx
}

export const useBackend = (): BackendClient => useSaip().backend
export const useHostAdapter = (): HostAdapter => useSaip().adapter
export const useHost = (): HostKind => useSaip().host
